function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { ComponentBootstrap } from '@demant/react-bootstrap';
import { Container, Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import richTextSchema from '@demant/react-bootstrap/lib/schemas/rich-text'; // import 'bootstrap/dist/css/bootstrap.min.css' loaded in sitecore PageTagSettings

import PropTypes from 'prop-types';
import axios from 'axios';

var RichTextModal = function RichTextModal(_ref) {
  var settings = _ref.settings,
      component = _ref.component;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      validated = _useState2[0],
      setValidated = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      cseaEligible = _useState6[0],
      setCseaEligible = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      cseaError = _useState8[0],
      setCseaError = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      show = _useState10[0],
      setShow = _useState10[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleSubmit = function handleSubmit(event) {
    var form = event.currentTarget;
    var formData = new FormData(form);
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidated(true);
    } // test id 1232259983


    if (form.checkValidity() === true) {
      setLoading(true);
      axios({
        method: 'post',
        url: 'https://www.cseany.org/verifyEligibility.php',
        data: formData
      }).then(function (res) {
        // console.log('RESPONSE RECEIVED: ', res);
        if (res.data.EligibilityResponse.EligibilityData.eligible === 'Y') {
          setCseaEligible(true);
          handleClose();
        }

        if (res.data.EligibilityResponse.EligibilityData.eligible === 'N') {
          form.reset();
          setCseaEligible(false);
          setCseaError(true);
        }

        setLoading(false);
      }).catch(function (err) {
        console.log('AXIOS ERROR: ', err);
      });
    }
  };

  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    backdrop: "static",
    keyboard: false
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "yh-bgcolor--blue"
  }, /*#__PURE__*/React.createElement(Modal.Title, null, "Verify CSEA Enrollment")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, null, settings.content.html)), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form, {
    noValidate: true,
    validated: validated,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Label, {
    htmlFor: "UID",
    srOnly: true
  }, "CSEA ID Number"), /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "formCseaId"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    name: "UID",
    type: "text",
    placeholder: "ex. 1234567890",
    maxLength: "10",
    minLength: "10",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    type: "invalid"
  }, cseaError ? 'CSEA ID not found. Please try again' : 'Please enter your CSEA ID'), cseaEligible && /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    type: "valid"
  }, "CSEA ID Verified!"))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    type: "submit"
  }, loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
    as: "span",
    animation: "border",
    size: "sm",
    role: "status",
    "aria-hidden": "true"
  }), ' ', "Verifying...") : /*#__PURE__*/React.createElement("span", null, "Submit")))))))));
};

RichTextModal.propTypes = {
  settings: PropTypes.shape({
    content: PropTypes.shape({
      html: PropTypes.objectOf(PropTypes.any)
    })
  }).isRequired,
  component: PropTypes.objectOf(PropTypes.any)
};
var myComponent = new ComponentBootstrap('.csea-modal');
myComponent.schemaData = richTextSchema;
myComponent.reactApp = RichTextModal;
myComponent.run();